module.exports = __webpack_public_path__ + "img/서브_공제어감각.332d3ce0.svg";